// 全局通用
import common from "./global/common";
import { campaignPushStatusList } from "./global/status";
import { genderTypeList, transactionTypeList, marketingEmailPushTypeList } from "./global/type";
// 按国家区分
import { applyStepData } from "./byCountry/applyStep";
import { governmentData } from "./byCountry/government";
import { serviceCodeData } from "./byCountry/serviceCode";
import { tradeData } from "./byCountry/trade";
import { provinceOrStateData } from "./byCountry/provinceOrState";
import {
  financialPeriodTypeData,
  identificationTypeData,
  entityTypeData,
  companyTypeData,
  raceTypeData,
  customizedConstitutionTypeData,
} from "./byCountry/type";

export default {
  namespaced: true,
  state: {
    // 全局通用
    ...common,
    campaignPushStatusList,
    genderTypeList,
    transactionTypeList,
    marketingEmailPushTypeList,
    // 按国家区分
    applyStepData,
    governmentData,
    serviceCodeData,
    tradeData,
    provinceOrStateData,
    financialPeriodTypeData,
    identificationTypeData,
    entityTypeData,
    companyTypeData,
    raceTypeData,
    customizedConstitutionTypeData,
  },
  getters: {
    // 根据国家和服务类型，来获取对应的服务code
    getServiceCodeMap: (state, getters, rootState) => (customCountry, customBusinessType) => {
      // 参数customCountry为空时，使用申请单(vuex中state.applyment.detail.country)中的国家
      const country = customCountry || rootState.applyment?.detail?.country;
      // 参数customBusinessType为空时，使用申请单(vuex中state.applyment.detail.businessType)中的服务类型
      const businessType = customBusinessType || rootState.applyment?.detail?.businessType;
      // 返回对应服务code映射对象
      const mapObj = state.serviceCodeData[country]?.[businessType] || {};
      return mapObj;
    },
    // 根据步骤key、国家、服务类型，获取申请步骤信息（{ step, title }）
    // country/businessType 为空时，自动取申请单(vuex)中的值
    getApplyStepInfo: (state, getters, rootState) => (stepKey, customCountry, customBusinessType) => {
      const country = customCountry || rootState.applyment?.detail?.country;
      const businessType = customBusinessType || rootState.applyment?.detail?.businessType;
      return state.applyStepData?.[country]?.[businessType]?.[stepKey] || {};
    },
    // 根据步骤key、国家、服务类型，获取step字符串
    // country/businessType 为空时，自动取申请单(vuex)中的值
    getApplyStep: (state, getters, rootState) => (stepKey, customCountry, customBusinessType) => {
      const country = customCountry || rootState.applyment?.detail?.country;
      const businessType = customBusinessType || rootState.applyment?.detail?.businessType;
      return state.applyStepData?.[country]?.[businessType]?.[stepKey]?.step;
    },
    // 根据国家、服务类型，获取step字符串列表（保持配置顺序）
    // country/businessType 为空时，自动取申请单(vuex)中的值
    getApplyStepList: (state, getters, rootState) => (customCountry, customBusinessType) => {
      const country = customCountry || rootState.applyment?.detail?.country;
      const businessType = customBusinessType || rootState.applyment?.detail?.businessType;
      const stepMap = state.applyStepData?.[country]?.[businessType] || {};
      return Object.keys(stepMap).map(key => stepMap[key].step);
    },
    // 根据key、国家，返回对应选项列表
    byCountryFormatList: state => (key, country) => {
      const rawList = state[key]?.[country] || [];
      return rawList;
    },
    // 根据key、国家、value，反推label
    byCountryFormatLabel: state => (key, country, value) => {
      const item = state[key]?.[country]?.find(item => item.value === value);
      return item?.title || value;
    },
    // 根据key、value，反推label
    globalFormatLabel: state => (key, value) => {
      const item = state[key]?.find(item => item.value === value);
      return item?.title || value;
    },
  },
};
